import { useState, useEffect } from "react";
import { Box, Button, Typography } from "@mui/material";
import { UseMagLandings } from "../UseMagLandings";
import { useRecoilState } from "recoil";
import { rsProgress } from "../../../RecoilStates";
import FiberManualRecordIcon from "@mui/icons-material/FiberManualRecord";
import SearchArticle from "./SearchArticle";
import useBreakpoints from "../../../hooks/useBreakpoints";

export default function AddLandingG(props) {
  const [progress, setProgress] = useRecoilState(rsProgress);
  const { validate, AddGroupArticle } = UseMagLandings();
  const [reset, setReset] = useState("");
  const [state, setState] = useState({
    LandingID: undefined,
    articleId: undefined,
    groupID: undefined,
  });
  const { isSmall } = useBreakpoints();
  useEffect(() => {
    if (props.groupDetails) {
      setState({
        ...state,
        groupID: props.groupDetails.id,
        LandingID: props.groupDetails.landingID,
      });
    }
  }, [props.groupDetails]);

  const [errorState, setErrorState] = useState({
    articleId: false,
  });

  return (
    <Box sx={{ mb: 4 }}>
      <Box sx={{ mb: 2, display: "flex", alignItems: "center", gap: 0.5 }}>
        <FiberManualRecordIcon color="secondary" fontSize="small" />
        <Typography color="secondary" variant="subtitle1">
          افزودن مقاله
        </Typography>
      </Box>
      <Box
        sx={{ alignItems: "center", gap: 2 }}
        display="grid"
        gridTemplateColumns="repeat(12, 1fr)"
        gap={1}
      >
        <Box gridColumn={isSmall ? "span 12" : "span  6"}>
          <SearchArticle
            reset={reset}
            setReset={setReset}
            error={errorState.articleId}
            setState={setState}
            state={state}
          />
        </Box>
        <Box
          sx={{ display: "flex", justifyContent: isSmall && "flex-end" }}
          gridColumn={isSmall ? "span 12" : "span  3"}
        >
          <Button
            sx={{ width: "100px" }}
            variant="contained"
            onClick={() => {
              if (validate(state, setErrorState) == 200) {
                setProgress(true);
                AddGroupArticle(state, (calback) => {
                  setReset(true);
                  props.callback(
                    props.groupDetails.landingID,
                    props.groupDetails.id
                  );
                });
              }
            }}
          >
            افزودن
          </Button>
        </Box>
      </Box>
    </Box>
  );
}
